export default function () {
  const el = document.getElementById('shopify-section-header')

  let scrollY = 0
  let lastScrollY = 0
  let direction: 'up' | 'down' = 'down'

  if (el) {
    setInterval(() => {
      if (scrollY > 200) {
        el.classList.add('is-sticky')
      } else {
        el.classList.remove('is-sticky')
      }
      if (direction === 'up') {
        el.classList.add('is-showing')
      } else {
        el.classList.remove('is-showing')
      }
    }, 500)

    const onUpdate = () => {
      lastScrollY = scrollY
      scrollY = window.scrollY
      direction = scrollY > lastScrollY ? 'down' : 'up'
    }

    document.addEventListener('scroll', onUpdate, { passive: true })
    document.addEventListener('resize', onUpdate, { passive: true })
  }

  const accountPopover = document.getElementsByClassName('Header__AccountLink')
  for (const popoverTrigger of accountPopover) {
    popoverTrigger.addEventListener('click', (e) => {
      const popover = document.getElementById('account-popover')
      if (popover) {
        e.preventDefault()
        e.stopPropagation()
        popover.classList.toggle('is-active')
      }
    })
  }

  document.addEventListener('click', (e) => {
    const popover = document.getElementById('account-popover')
    if (popover && !popover.contains(e.target as Node)) {
      popover.classList.remove('is-active')
    }
  })
}
